import { axiosRequest } from "../service";
import {
  REACT_APP_VAM_ENDPOINT,REACT_APP_VAM_CONTEXT_CALCULATE,
  AUDIT_SERVICE,
  REACT_APP_VAM_CONTEXT_MASTER,
  CALCULATION_SERVICE
} from "../urls";

export const getDefaultLossReservePercentage = async (productID,date) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER}/loss-reserve/${productID}?requestedDate=${date}`)      
    return response?.data;
  } catch (error) {
    return null;
  }
};
export const getLossReserveAudit = async (claimId) => {
  try {
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${AUDIT_SERVICE}/loss-reserve/audit/${claimId}`);
    return response;
  } catch (error) {
    return null;
  }
};
export const calculateLossReserveValue = async (payload) => {
  try {
    const response = await axiosRequest().post(
      `${REACT_APP_VAM_ENDPOINT}/${CALCULATION_SERVICE}/calculate/loss-reserve`,payload
    );
    return response?.data;
  } catch (error) {
    return null;
  }
};
export const getCalculationList = async (claim) => {
  try {
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_CALCULATE}/getGISNum/${claim.claimNo}`)
    return response.data
  } catch (e) { return null }

}
export const getCalculations = async (claim) => {
  try {
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_CALCULATE}/getCalcHistory/${claim.claimNo}`)
    return response.data
  } catch (e) { return null }
}



